import {
  emailFoot,
  emailHead,
  EmailTemplate,
  EmailTemplateProps,
} from "src/components/email/EmailTemplate";

const sampleData: EmailTemplateProps = {
  logo: "https://api.captyn.com/s3/b74eb101-e2d0-4656-943f-a95d15ed7dda",
  subhead: "",
  content:
    "<p>Dear Frank,</p><p>Your enrollment summary is below.</p><p>To manage your enrollments, sign in anytime.</p><p>Sincerely,<br />Naples Swim School</p>",
  move: {
    participantName: "Frank the Tank",
    participantMeta: "8 years • Female",
    from: {
      department: "Jims",
      tags: ["Jones", "Bones"],
      program: "Swimming Fundamentals",
      classTimes: [
        {
          day: "M",
          date: "",
          startTime: "8 am",
          endTime: "8:30 am",
          instructor: "Jerry Barmore",
          location: "Naples",
          zone: "Area 1",
        },
        {
          day: "T",
          date: "",
          startTime: "7:45 am",
          endTime: "8:45 am",
          instructor: "Frank Jones",
          location: "Swimming Pool",
        },
      ],
      locations: [
        {
          name: "Location Name",
          address: "1213 Airport-Pulling Rd. North",
          city: "Naples",
          state: "FL",
          zip: "34105",
          mapUrl: "#",
        },
      ],
      contact: {
        name: "Melissa Jenkins",
        email: "mjenkins@naples.com",
        phone: "919-299-3131",
      },
    },
    to: {
      program: "30 Minute Lessons",
      ages: "",
      lessons: "3",
      duration: "30",
      remainingLessons: "2",
      scheduledThrough: "Jun 15, 2019",
      instructor: "Jerry Barmore",
      classTimes: [
        {
          day: "M",
          date: "",
          startTime: "8 am",
          endTime: "8:30 am",
          instructor: "Jerry Barmore",
          location: "Naples",
          zone: "Area 1",
        },
        {
          day: "T",
          date: "",
          startTime: "7:45 am",
          endTime: "8:45 am",
          instructor: "Frank Jones",
          location: "Swimming Pool",
        },
      ],
    },
  },
  organizationUrl: "naples.captyn.com",
  organizationName: "Naples Swim School",
};

export default function EmailTest() {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: emailHead }} />
      <EmailTemplate {...sampleData} />
      <div dangerouslySetInnerHTML={{ __html: emailFoot }} />
    </>
  );
}
